import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { BasePageComponent } from '../../../base-page';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';

@Component({
  selector: 'page-icons-sli',
  templateUrl: './icons-sli.component.html',
  styleUrls: ['./icons-sli.component.scss']
})
export class PageIconsSliComponent extends BasePageComponent implements OnInit, OnDestroy {
  icons: string[];

  constructor(
    store: Store<IAppState>,
    httpSv: HttpService
  ) {
    super(store, httpSv);

    this.icons = [];

    this.pageData = {
      title: 'Simple line icons',
      key: '',
      breadcrumbs: [
        {
          title: 'UI Kit',
          key: '',
          route: 'dashboard'
        },
        {
          title: 'Icons',
          key: '',
          route: 'dashboard'
        },
        {
          title: 'Simple line',
          key: ''
        }
      ]
    };
  }

  ngOnInit() {
    super.ngOnInit();

    this.getData('assets/data/icons-simpleline.json', 'icons', 'setLoaded');
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
